// Auto-generated resource for Practices — DO NOT EDIT.
// Regenerate via `dotnet run --project backend/tools/BackendTypesGenerator`.
// Projection of the backend resource JSON — keys, value catalogs (per
// culture), and string-literal unions. Hand-editing drifts from the source.

export const PracticesKeys = {
  Common: {
    PlaygroundKicker: 'Practices.Common.PlaygroundKicker',
    MasteryKicker: 'Practices.Common.MasteryKicker',
    PauseRecording: 'Practices.Common.PauseRecording',
    ResumeRecording: 'Practices.Common.ResumeRecording',
    StartRecording: 'Practices.Common.StartRecording',
    StartRecordingAria: 'Practices.Common.StartRecordingAria',
    LeaveStopConfirm: 'Practices.Common.LeaveStopConfirm',
    WritingStory: 'Practices.Common.WritingStory',
    GeneratingStory: 'Practices.Common.GeneratingStory',
    TryAgain: 'Practices.Common.TryAgain',
    DownloadingModel: 'Practices.Common.DownloadingModel',
    LoadingModel: 'Practices.Common.LoadingModel',
    ModelUnavailable: 'Practices.Common.ModelUnavailable',
    QuotaRemainingOne: 'Practices.Common.QuotaRemainingOne',
    QuotaRemainingMany: 'Practices.Common.QuotaRemainingMany',
    DailyLimitReached: 'Practices.Common.DailyLimitReached',
    DailyLimitReachedLogIn: 'Practices.Common.DailyLimitReachedLogIn',
    PracticeLength: 'Practices.Common.PracticeLength',
    PracticeLengthAria: 'Practices.Common.PracticeLengthAria',
    MinSuffix: 'Practices.Common.MinSuffix',
    TargetPace: 'Practices.Common.TargetPace',
    TargetPaceAria: 'Practices.Common.TargetPaceAria',
    TargetPaceUnit: 'Practices.Common.TargetPaceUnit',
    TargetPaceHint: 'Practices.Common.TargetPaceHint',
    TargetPaceOutOfRange: 'Practices.Common.TargetPaceOutOfRange',
    TargetWordsSummaryOne: 'Practices.Common.TargetWordsSummaryOne',
    TargetWordsSummaryMany: 'Practices.Common.TargetWordsSummaryMany',
    TargetWordsFloorNote: 'Practices.Common.TargetWordsFloorNote',
    TopicLabel: 'Practices.Common.TopicLabel',
    TopicAnything: 'Practices.Common.TopicAnything',
    UseDefault: 'Practices.Common.UseDefault',
    CustomTopic: 'Practices.Common.CustomTopic',
  },
  CueVisual: {
    Paused: 'Practices.CueVisual.Paused',
    ArchetypeEnergy: 'Practices.CueVisual.ArchetypeEnergy',
    RiffHelp: 'Practices.CueVisual.RiffHelp',
    MixedFamily: {
      Auditory: 'Practices.CueVisual.MixedFamily.Auditory',
      Visual: 'Practices.CueVisual.MixedFamily.Visual',
      Archetype: 'Practices.CueVisual.MixedFamily.Archetype',
      Help: 'Practices.CueVisual.MixedFamily.Help',
    },
    Help: 'Practices.CueVisual.Help',
    HelpDone: 'Practices.CueVisual.HelpDone',
    Nudge: 'Practices.CueVisual.Nudge',
    HelpIdle: 'Practices.CueVisual.HelpIdle',
  },
  Instrument: {
    Title: 'Practices.Instrument.Title',
    MetaDescription: 'Practices.Instrument.MetaDescription',
    Heading: 'Practices.Instrument.Heading',
    Lead: 'Practices.Instrument.Lead',
    AbortHeading: 'Practices.Instrument.AbortHeading',
    AbortBody: 'Practices.Instrument.AbortBody',
    KeysHeading: 'Practices.Instrument.KeysHeading',
    KeysIntro: 'Practices.Instrument.KeysIntro',
    TechniquesHeading: 'Practices.Instrument.TechniquesHeading',
    ExplainKeyAria: 'Practices.Instrument.ExplainKeyAria',
    ExplainTechniqueAria: 'Practices.Instrument.ExplainTechniqueAria',
    AiGuideLabel: 'Practices.Instrument.AiGuideLabel',
    ResumePlaygroundAria: 'Practices.Instrument.ResumePlaygroundAria',
    StartPlaygroundAria: 'Practices.Instrument.StartPlaygroundAria',
    StartOffline: 'Practices.Instrument.StartOffline',
    ResumePlaying: 'Practices.Instrument.ResumePlaying',
    StartPlaying: 'Practices.Instrument.StartPlaying',
    Encourage: 'Practices.Instrument.Encourage',
    ReviewTooltip: 'Practices.Instrument.ReviewTooltip',
    Keys: {
      Rate: {
        Tagline: 'Practices.Instrument.Keys.Rate.Tagline',
        Guide: 'Practices.Instrument.Keys.Rate.Guide',
      },
      Volume: {
        Tagline: 'Practices.Instrument.Keys.Volume.Tagline',
        Guide: 'Practices.Instrument.Keys.Volume.Guide',
      },
      Pitch: {
        Tagline: 'Practices.Instrument.Keys.Pitch.Tagline',
        Guide: 'Practices.Instrument.Keys.Pitch.Guide',
      },
      Tonality: {
        Tagline: 'Practices.Instrument.Keys.Tonality.Tagline',
        Guide: 'Practices.Instrument.Keys.Tonality.Guide',
      },
      Pause: {
        Tagline: 'Practices.Instrument.Keys.Pause.Tagline',
        Guide: 'Practices.Instrument.Keys.Pause.Guide',
      },
      Phrasing: {
        Tagline: 'Practices.Instrument.Keys.Phrasing.Tagline',
        Guide: 'Practices.Instrument.Keys.Phrasing.Guide',
      },
      Siren: {
        Tagline: 'Practices.Instrument.Keys.Siren.Tagline',
        Guide: 'Practices.Instrument.Keys.Siren.Guide',
      },
    },
  },
  Archetypes: {
    Title: 'Practices.Archetypes.Title',
    MetaDescription: 'Practices.Archetypes.MetaDescription',
    Heading: 'Practices.Archetypes.Heading',
    Lead: 'Practices.Archetypes.Lead',
    SequenceHeading: 'Practices.Archetypes.SequenceHeading',
    Randomise: 'Practices.Archetypes.Randomise',
    Reset: 'Practices.Archetypes.Reset',
    SequenceModeAria: 'Practices.Archetypes.SequenceModeAria',
    ModeClassic: 'Practices.Archetypes.ModeClassic',
    ModeMixMatch: 'Practices.Archetypes.ModeMixMatch',
    ClassicHint: 'Practices.Archetypes.ClassicHint',
    MixHint: 'Practices.Archetypes.MixHint',
    BookendTitle: 'Practices.Archetypes.BookendTitle',
    ExplainFriendAria: 'Practices.Archetypes.ExplainFriendAria',
    ExplainSignatureAria: 'Practices.Archetypes.ExplainSignatureAria',
    ReorderAria: 'Practices.Archetypes.ReorderAria',
    IncludeAria: 'Practices.Archetypes.IncludeAria',
    RemoveShiftAria: 'Practices.Archetypes.RemoveShiftAria',
    AddShift: 'Practices.Archetypes.AddShift',
    MixCount: 'Practices.Archetypes.MixCount',
    MixInvalid: 'Practices.Archetypes.MixInvalid',
    VocalSignatureLabel: 'Practices.Archetypes.VocalSignatureLabel',
    AbortHeading: 'Practices.Archetypes.AbortHeading',
    AbortBody: 'Practices.Archetypes.AbortBody',
    StartCardCopy: 'Practices.Archetypes.StartCardCopy',
    GenerateOfflineStart: 'Practices.Archetypes.GenerateOfflineStart',
    ResumeSession: 'Practices.Archetypes.ResumeSession',
    GenerateStoryStart: 'Practices.Archetypes.GenerateStoryStart',
    GuideTitle: 'Practices.Archetypes.GuideTitle',
    DefaultStoryTitle: 'Practices.Archetypes.DefaultStoryTitle',
    StoryKindLabel: 'Practices.Archetypes.StoryKindLabel',
    ReviewTooltip: 'Practices.Archetypes.ReviewTooltip',
    Signatures: {
      Friend: {
        Role: 'Practices.Archetypes.Signatures.Friend.Role',
        Tagline: 'Practices.Archetypes.Signatures.Friend.Tagline',
        Signature: {
          Rate: 'Practices.Archetypes.Signatures.Friend.Signature.Rate',
          Pitch: 'Practices.Archetypes.Signatures.Friend.Signature.Pitch',
          Tonality: 'Practices.Archetypes.Signatures.Friend.Signature.Tonality',
          Address: 'Practices.Archetypes.Signatures.Friend.Signature.Address',
        },
        DoNow: {
          Rate: 'Practices.Archetypes.Signatures.Friend.DoNow.Rate',
          Pitch: 'Practices.Archetypes.Signatures.Friend.DoNow.Pitch',
          Tonality: 'Practices.Archetypes.Signatures.Friend.DoNow.Tonality',
          Address: 'Practices.Archetypes.Signatures.Friend.DoNow.Address',
        },
      },
      Motivator: {
        Role: 'Practices.Archetypes.Signatures.Motivator.Role',
        Tagline: 'Practices.Archetypes.Signatures.Motivator.Tagline',
        Signature: {
          Volume: 'Practices.Archetypes.Signatures.Motivator.Signature.Volume',
          Gesture: 'Practices.Archetypes.Signatures.Motivator.Signature.Gesture',
          Phrasing: 'Practices.Archetypes.Signatures.Motivator.Signature.Phrasing',
          Energy: 'Practices.Archetypes.Signatures.Motivator.Signature.Energy',
        },
        DoNow: {
          Volume: 'Practices.Archetypes.Signatures.Motivator.DoNow.Volume',
          Gesture: 'Practices.Archetypes.Signatures.Motivator.DoNow.Gesture',
          Phrasing: 'Practices.Archetypes.Signatures.Motivator.DoNow.Phrasing',
          Energy: 'Practices.Archetypes.Signatures.Motivator.DoNow.Energy',
        },
      },
      Educator: {
        Role: 'Practices.Archetypes.Signatures.Educator.Role',
        Tagline: 'Practices.Archetypes.Signatures.Educator.Tagline',
        Signature: {
          Pause: 'Practices.Archetypes.Signatures.Educator.Signature.Pause',
          Pitch: 'Practices.Archetypes.Signatures.Educator.Signature.Pitch',
          Rate: 'Practices.Archetypes.Signatures.Educator.Signature.Rate',
          Articulation: 'Practices.Archetypes.Signatures.Educator.Signature.Articulation',
        },
        DoNow: {
          Pause: 'Practices.Archetypes.Signatures.Educator.DoNow.Pause',
          Pitch: 'Practices.Archetypes.Signatures.Educator.DoNow.Pitch',
          Rate: 'Practices.Archetypes.Signatures.Educator.DoNow.Rate',
          Articulation: 'Practices.Archetypes.Signatures.Educator.DoNow.Articulation',
        },
      },
      Coach: {
        Role: 'Practices.Archetypes.Signatures.Coach.Role',
        Tagline: 'Practices.Archetypes.Signatures.Coach.Tagline',
        Signature: {
          Phrasing: 'Practices.Archetypes.Signatures.Coach.Signature.Phrasing',
          Fillers: 'Practices.Archetypes.Signatures.Coach.Signature.Fillers',
          Tonality: 'Practices.Archetypes.Signatures.Coach.Signature.Tonality',
          Inflection: 'Practices.Archetypes.Signatures.Coach.Signature.Inflection',
        },
        DoNow: {
          Phrasing: 'Practices.Archetypes.Signatures.Coach.DoNow.Phrasing',
          Fillers: 'Practices.Archetypes.Signatures.Coach.DoNow.Fillers',
          Tonality: 'Practices.Archetypes.Signatures.Coach.DoNow.Tonality',
          Inflection: 'Practices.Archetypes.Signatures.Coach.DoNow.Inflection',
        },
      },
    },
  },
  BodyLanguage: {
    Title: 'Practices.BodyLanguage.Title',
    MetaDescription: 'Practices.BodyLanguage.MetaDescription',
    Heading: 'Practices.BodyLanguage.Heading',
    Lead: 'Practices.BodyLanguage.Lead',
    AbortHeading: 'Practices.BodyLanguage.AbortHeading',
    AbortBody: 'Practices.BodyLanguage.AbortBody',
    GuideHeading: 'Practices.BodyLanguage.GuideHeading',
    GuideIntro: 'Practices.BodyLanguage.GuideIntro',
    IncludeAria: 'Practices.BodyLanguage.IncludeAria',
    NoGesturesSelected: 'Practices.BodyLanguage.NoGesturesSelected',
    ExplainAria: 'Practices.BodyLanguage.ExplainAria',
    Credit: 'Practices.BodyLanguage.Credit',
    IntroCopy: 'Practices.BodyLanguage.IntroCopy',
    GenerateOfflineStart: 'Practices.BodyLanguage.GenerateOfflineStart',
    ResumeSession: 'Practices.BodyLanguage.ResumeSession',
    GenerateStoryStart: 'Practices.BodyLanguage.GenerateStoryStart',
    NewStory: 'Practices.BodyLanguage.NewStory',
    DefaultStoryTitle: 'Practices.BodyLanguage.DefaultStoryTitle',
    StoryKindLabel: 'Practices.BodyLanguage.StoryKindLabel',
    ReviewTooltip: 'Practices.BodyLanguage.ReviewTooltip',
    Guides: {
      Posture: {
        Title: 'Practices.BodyLanguage.Guides.Posture.Title',
        Body: 'Practices.BodyLanguage.Guides.Posture.Body',
      },
      Gesture: {
        Title: 'Practices.BodyLanguage.Guides.Gesture.Title',
        Body: 'Practices.BodyLanguage.Guides.Gesture.Body',
      },
      Facial: {
        Title: 'Practices.BodyLanguage.Guides.Facial.Title',
        Body: 'Practices.BodyLanguage.Guides.Facial.Body',
      },
      Movement: {
        Title: 'Practices.BodyLanguage.Guides.Movement.Title',
        Body: 'Practices.BodyLanguage.Guides.Movement.Body',
      },
      EyeContact: {
        Title: 'Practices.BodyLanguage.Guides.EyeContact.Title',
        Body: 'Practices.BodyLanguage.Guides.EyeContact.Body',
      },
    },
  },
  Storytelling: {
    Title: 'Practices.Storytelling.Title',
    MetaDescription: 'Practices.Storytelling.MetaDescription',
    Heading: 'Practices.Storytelling.Heading',
    Lead: 'Practices.Storytelling.Lead',
    ModeImprov: 'Practices.Storytelling.ModeImprov',
    ModeOffBook: 'Practices.Storytelling.ModeOffBook',
    ModeAria: 'Practices.Storytelling.ModeAria',
    ModeLockedAria: 'Practices.Storytelling.ModeLockedAria',
    AbortHeading: 'Practices.Storytelling.AbortHeading',
    TopicLegend: 'Practices.Storytelling.TopicLegend',
    SetupAria: 'Practices.Storytelling.SetupAria',
    TopicPlaceholder: 'Practices.Storytelling.TopicPlaceholder',
    TopicSuggestionsLabel: 'Practices.Storytelling.TopicSuggestionsLabel',
    TopicMoreIdeas: 'Practices.Storytelling.TopicMoreIdeas',
    ShapeLegend: 'Practices.Storytelling.ShapeLegend',
    ShapeHeading: 'Practices.Storytelling.ShapeHeading',
    NoExtraLenses: 'Practices.Storytelling.NoExtraLenses',
    FrameworkAria: 'Practices.Storytelling.FrameworkAria',
    FrameworkStorytellingFormula: 'Practices.Storytelling.FrameworkStorytellingFormula',
    EnrichLegend: 'Practices.Storytelling.EnrichLegend',
    EnrichOptional: 'Practices.Storytelling.EnrichOptional',
    VaksDescription: 'Practices.Storytelling.VaksDescription',
    AmsDescription: 'Practices.Storytelling.AmsDescription',
    TakeLengthLabel: 'Practices.Storytelling.TakeLengthLabel',
    TakeLengthAria: 'Practices.Storytelling.TakeLengthAria',
    StartSession: 'Practices.Storytelling.StartSession',
    WritingTopic: 'Practices.Storytelling.WritingTopic',
    SpineTitle: 'Practices.Storytelling.SpineTitle',
    StartRecording: 'Practices.Storytelling.StartRecording',
    DefaultTopicTitle: 'Practices.Storytelling.DefaultTopicTitle',
    TopicKindLabel: 'Practices.Storytelling.TopicKindLabel',
    TellingEyebrow: 'Practices.Storytelling.TellingEyebrow',
    NewTopic: 'Practices.Storytelling.NewTopic',
    ReviewTooltip: 'Practices.Storytelling.ReviewTooltip',
  },
  OffBook: {
    GuideHeading: 'Practices.OffBook.GuideHeading',
    GuideHint: 'Practices.OffBook.GuideHint',
    AbortHeading: 'Practices.OffBook.AbortHeading',
    Step1Heading: 'Practices.OffBook.Step1Heading',
    StoryLabel: 'Practices.OffBook.StoryLabel',
    StoryPlaceholder: 'Practices.OffBook.StoryPlaceholder',
    ShapeLegend: 'Practices.OffBook.ShapeLegend',
    FrameworkAria: 'Practices.OffBook.FrameworkAria',
    FrameworkStorytellingFormula: 'Practices.OffBook.FrameworkStorytellingFormula',
    EnrichLegend: 'Practices.OffBook.EnrichLegend',
    EnrichOptional: 'Practices.OffBook.EnrichOptional',
    VaksDescription: 'Practices.OffBook.VaksDescription',
    AmsDescription: 'Practices.OffBook.AmsDescription',
    TakeLengthLabel: 'Practices.OffBook.TakeLengthLabel',
    TakeLengthAria: 'Practices.OffBook.TakeLengthAria',
    TakeLengthHint: 'Practices.OffBook.TakeLengthHint',
    WithCuesAria: 'Practices.OffBook.WithCuesAria',
    WithCuesLabel: 'Practices.OffBook.WithCuesLabel',
    WithCuesHint: 'Practices.OffBook.WithCuesHint',
    RewriteRehearse: 'Practices.OffBook.RewriteRehearse',
    AddStoryFirst: 'Practices.OffBook.AddStoryFirst',
    Step2Heading: 'Practices.OffBook.Step2Heading',
    RewritingStory: 'Practices.OffBook.RewritingStory',
    ReadyHint: 'Practices.OffBook.ReadyHint',
    StartRecording: 'Practices.OffBook.StartRecording',
    HideStory: 'Practices.OffBook.HideStory',
    HideCues: 'Practices.OffBook.HideCues',
    DefaultStoryTitle: 'Practices.OffBook.DefaultStoryTitle',
    StoryKindLabel: 'Practices.OffBook.StoryKindLabel',
    TellingEyebrow: 'Practices.OffBook.TellingEyebrow',
    NewStory: 'Practices.OffBook.NewStory',
    ReviewTooltip: 'Practices.OffBook.ReviewTooltip',
  },
  ActiveListening: {
    Title: 'Practices.ActiveListening.Title',
    MetaDescription: 'Practices.ActiveListening.MetaDescription',
    Heading: 'Practices.ActiveListening.Heading',
    Lead: 'Practices.ActiveListening.Lead',
    GateGuest: 'Practices.ActiveListening.GateGuest',
    GateOutOfCredits: 'Practices.ActiveListening.GateOutOfCredits',
    ModeHeading: 'Practices.ActiveListening.ModeHeading',
    ModeLabel: 'Practices.ActiveListening.ModeLabel',
    ModeRespond: 'Practices.ActiveListening.ModeRespond',
    ModeRespondHint: 'Practices.ActiveListening.ModeRespondHint',
    ModeRespondNoteReplay: 'Practices.ActiveListening.ModeRespondNoteReplay',
    ModeRespondNoteReview: 'Practices.ActiveListening.ModeRespondNoteReview',
    ModeLive: 'Practices.ActiveListening.ModeLive',
    ModeLiveHint: 'Practices.ActiveListening.ModeLiveHint',
    ModeLiveNoteFeedback: 'Practices.ActiveListening.ModeLiveNoteFeedback',
    ModeLiveNoteHeadphones: 'Practices.ActiveListening.ModeLiveNoteHeadphones',
    Step1Heading: 'Practices.ActiveListening.Step1Heading',
    Step1Copy: 'Practices.ActiveListening.Step1Copy',
    SpeakerCostOne: 'Practices.ActiveListening.SpeakerCostOne',
    SpeakerCostMany: 'Practices.ActiveListening.SpeakerCostMany',
    GenerateSpeaker: 'Practices.ActiveListening.GenerateSpeaker',
    Generating: 'Practices.ActiveListening.Generating',
    WritingPassage: 'Practices.ActiveListening.WritingPassage',
    SpeakerVoiceUnavailable: 'Practices.ActiveListening.SpeakerVoiceUnavailable',
    GenerateFailed: 'Practices.ActiveListening.GenerateFailed',
    GenerateTimedOut: 'Practices.ActiveListening.GenerateTimedOut',
    SessionStartFailed: 'Practices.ActiveListening.SessionStartFailed',
    SpeakerHeading: 'Practices.ActiveListening.SpeakerHeading',
    ShowTranscript: 'Practices.ActiveListening.ShowTranscript',
    HideTranscript: 'Practices.ActiveListening.HideTranscript',
    Step2Copy: 'Practices.ActiveListening.Step2Copy',
    DefaultSpeakerTitle: 'Practices.ActiveListening.DefaultSpeakerTitle',
    ReviewTooltip: 'Practices.ActiveListening.ReviewTooltip',
    PractiseAgain: 'Practices.ActiveListening.PractiseAgain',
    Guide: {
      Heading: 'Practices.ActiveListening.Guide.Heading',
      Intro: 'Practices.ActiveListening.Guide.Intro',
      Lanes: {
        Content: 'Practices.ActiveListening.Guide.Lanes.Content',
        Mood: 'Practices.ActiveListening.Guide.Lanes.Mood',
        Vocal: 'Practices.ActiveListening.Guide.Lanes.Vocal',
        Body: 'Practices.ActiveListening.Guide.Lanes.Body',
      },
      AvoidHeading: 'Practices.ActiveListening.Guide.AvoidHeading',
      Traps: {
        Judging: 'Practices.ActiveListening.Guide.Traps.Judging',
        Advising: 'Practices.ActiveListening.Guide.Traps.Advising',
        OneUpping: 'Practices.ActiveListening.Guide.Traps.OneUpping',
        MindReading: 'Practices.ActiveListening.Guide.Traps.MindReading',
      },
    },
    Demo: {
      Note: 'Practices.ActiveListening.Demo.Note',
      SpeakerTitle: 'Practices.ActiveListening.Demo.SpeakerTitle',
      SpeakerName: 'Practices.ActiveListening.Demo.SpeakerName',
      SpeakerOne: 'Practices.ActiveListening.Demo.SpeakerOne',
      SpeakerTwo: 'Practices.ActiveListening.Demo.SpeakerTwo',
      SpeakerThree: 'Practices.ActiveListening.Demo.SpeakerThree',
      YouOne: 'Practices.ActiveListening.Demo.YouOne',
      YouTwo: 'Practices.ActiveListening.Demo.YouTwo',
    },
  },
  WordPlay: {
    Title: 'Practices.WordPlay.Title',
    MetaDescription: 'Practices.WordPlay.MetaDescription',
    Heading: 'Practices.WordPlay.Heading',
    Lead: 'Practices.WordPlay.Lead',
    GuideAria: 'Practices.WordPlay.GuideAria',
    GuideHeading: 'Practices.WordPlay.GuideHeading',
    GuideCopy: 'Practices.WordPlay.GuideCopy',
    AbortHeading: 'Practices.WordPlay.AbortHeading',
    AbortBody: 'Practices.WordPlay.AbortBody',
    IntroCopy: 'Practices.WordPlay.IntroCopy',
    HelpPromptsHint: 'Practices.WordPlay.HelpPromptsHint',
    WebGpuRequired: 'Practices.WordPlay.WebGpuRequired',
    ResumeSession: 'Practices.WordPlay.ResumeSession',
    StartRiffing: 'Practices.WordPlay.StartRiffing',
    PickingWord: 'Practices.WordPlay.PickingWord',
    WordKindLabel: 'Practices.WordPlay.WordKindLabel',
    YourWordEyebrow: 'Practices.WordPlay.YourWordEyebrow',
    DownloadWordPrefix: 'Practices.WordPlay.DownloadWordPrefix',
    DownloadHelpHeading: 'Practices.WordPlay.DownloadHelpHeading',
    NewWord: 'Practices.WordPlay.NewWord',
  },
} as const;

export const PracticesValues = {
  'default': {
    'ActiveListening.DefaultSpeakerTitle': 'The speaker',
    'ActiveListening.Demo.Note': 'These are examples of both ways to practise — a sample speaker and lines, not a real take.',
    'ActiveListening.Demo.SpeakerName': 'Maya',
    'ActiveListening.Demo.SpeakerOne': 'I ran my first half marathon on Sunday. Around mile ten my legs just stopped listening.',
    'ActiveListening.Demo.SpeakerThree': 'Then my sister jumped out of the crowd and ran the last mile with me — still in her jeans.',
    'ActiveListening.Demo.SpeakerTitle': 'The last mile',
    'ActiveListening.Demo.SpeakerTwo': 'I walked for a bit, and honestly, I nearly quit right there.',
    'ActiveListening.Demo.YouOne': 'So you nearly gave up at mile ten, and your sister carried you to the finish.',
    'ActiveListening.Demo.YouTwo': 'Your voice dropped when you said you walked, and lifted when she showed up. You sound proud — and touched that she was there.',
    'ActiveListening.GateGuest': 'Practise listening with an AI speaker. Reflect their story back, or talk with them live and get spoken feedback.',
    'ActiveListening.GateOutOfCredits': 'You\'re out of AI credits. Add credits to start a session.',
    'ActiveListening.GenerateFailed': 'Could not generate the speaker. Please try again.',
    'ActiveListening.GenerateSpeaker': 'Generate AI speaker',
    'ActiveListening.GenerateTimedOut': 'The speaker took too long to generate. Please try again.',
    'ActiveListening.Generating': 'Generating…',
    'ActiveListening.Guide.AvoidHeading': 'Avoid',
    'ActiveListening.Guide.Heading': 'Reflect back',
    'ActiveListening.Guide.Intro': 'You just heard someone talk. Now speak to them as if they were right in front of you, and tell them what you took in — so they feel **heard**.',
    'ActiveListening.Guide.Lanes.Body': '**Body language** — you only heard them, so imagine it from their voice. *“I picture you …”*',
    'ActiveListening.Guide.Lanes.Content': '**Content** — what they told you, in your own words. *“So what happened was…”*',
    'ActiveListening.Guide.Lanes.Mood': '**Mood & emotion** — name what they felt. *“You sound …”*',
    'ActiveListening.Guide.Lanes.Vocal': '**Vocal changes** — where their voice shifted. *“When you said …, your voice …”*',
    'ActiveListening.Guide.Traps.Advising': '**Advising** — *“What you should do is…”*',
    'ActiveListening.Guide.Traps.Judging': '**Judging** — *“You shouldn\'t have…”*',
    'ActiveListening.Guide.Traps.MindReading': '**Mind-reading** — *“What you really mean is…”*',
    'ActiveListening.Guide.Traps.OneUpping': '**One-upping** — *“That\'s nothing, once I…”*',
    'ActiveListening.Heading': 'Active Listening',
    'ActiveListening.HideTranscript': 'Hide transcript',
    'ActiveListening.Lead': 'An AI plays a speaker. Listen, then reflect back their content, mood, voice and body language, without judging or advising.',
    'ActiveListening.MetaDescription': 'Active Listening — practise reflecting back content, mood, vocal changes, and body language with an AI speaker.',
    'ActiveListening.ModeHeading': 'How\'d you like to practise?',
    'ActiveListening.ModeLabel': 'Active Listening mode',
    'ActiveListening.ModeLive': 'Live convo',
    'ActiveListening.ModeLiveHint': 'Talk in real time with an AI speaker who shares a story and reacts to how you reflect.',
    'ActiveListening.ModeLiveNoteFeedback': 'It ends with spoken feedback on your listening.',
    'ActiveListening.ModeLiveNoteHeadphones': 'Wear headphones, so it can\'t hear itself and cut in.',
    'ActiveListening.ModeRespond': 'Listen & respond',
    'ActiveListening.ModeRespondHint': 'An AI speaker tells you a short story; you play it, then record yourself reflecting it back.',
    'ActiveListening.ModeRespondNoteReplay': 'Play the speaker as often as you need before you record.',
    'ActiveListening.ModeRespondNoteReview': 'Send the take for AI Review on how well you reflected.',
    'ActiveListening.PractiseAgain': 'Practise again',
    'ActiveListening.ReviewTooltip': 'Record at least a minute to request an AI Review.',
    'ActiveListening.SessionStartFailed': 'Could not start your reflection take. Please try again.',
    'ActiveListening.ShowTranscript': 'Show transcript',
    'ActiveListening.SpeakerCostMany': 'Generating a speaker costs {Credits} AI credits.',
    'ActiveListening.SpeakerCostOne': 'Generating a speaker costs {Credits} AI credit.',
    'ActiveListening.SpeakerHeading': 'The speaker · {Title}',
    'ActiveListening.SpeakerVoiceUnavailable': 'The AI speaker voice is not available right now. Please try again later.',
    'ActiveListening.Step1Copy': 'Generate a short spoken passage. Play it as many times as you need — notice not just the words, but the mood and the delivery.',
    'ActiveListening.Step1Heading': '1 · Listen to the speaker',
    'ActiveListening.Step2Copy': 'Play the speaker as often as you need, then record yourself reflecting back — the guide below shows how.',
    'ActiveListening.Title': 'Active Listening · VoiceDojo',
    'ActiveListening.WritingPassage': 'Writing your speaker passage…',
    'Archetypes.AbortBody': 'The AI guide gave up after three attempts. Your daily practice slot has been refunded.',
    'Archetypes.AbortHeading': 'We couldn’t generate your story',
    'Archetypes.AddShift': '+ Add shift',
    'Archetypes.BookendTitle': 'Connection bookend — always on',
    'Archetypes.ClassicHint': 'The default arc bookends with Friend — Connection → WHY → WHAT → HOW → Connection. Reorder the steps, randomise the middle, or untick an archetype to drop it from the practice flow.',
    'Archetypes.DefaultStoryTitle': 'Your story',
    'Archetypes.ExplainFriendAria': 'Explain the Friend vocal signature',
    'Archetypes.ExplainSignatureAria': 'Explain the {Archetype} vocal signature',
    'Archetypes.GenerateOfflineStart': 'Generate offline & start',
    'Archetypes.GenerateStoryStart': 'Generate story & start',
    'Archetypes.GuideTitle': 'Archetype guide',
    'Archetypes.Heading': 'Archetype',
    'Archetypes.IncludeAria': 'Include {Archetype} in the practice',
    'Archetypes.Lead': 'Practise shifting through the four vocal archetypes — Friend, Motivator, Educator, Coach. The AI writes a story to read while live cues prompt each switch.',
    'Archetypes.MetaDescription': 'Archetype — practise shifting through the vocal archetypes Friend, Motivator, Educator, and Coach.',
    'Archetypes.MixCount': '{Count} shifts (max {Max} for {Minutes} min)',
    'Archetypes.MixHint': 'Build your own arc — Friend opens and closes it, and no two shifts in a row repeat an archetype. Add, remove, reorder, or randomise the middle. For a {Minutes}-minute take you can run up to {MaxShifts} shifts (each held 10–60 s).',
    'Archetypes.MixInvalid': 'Add at least 5 shifts with no two in a row repeating an archetype.',
    'Archetypes.ModeClassic': 'Classic ladder',
    'Archetypes.ModeMixMatch': 'Mix & match',
    'Archetypes.Randomise': 'Randomise',
    'Archetypes.RemoveShiftAria': 'Remove {Archetype} shift',
    'Archetypes.ReorderAria': 'Reorder {Archetype}',
    'Archetypes.Reset': 'Reset',
    'Archetypes.ResumeSession': 'Resume session',
    'Archetypes.ReviewTooltip': 'Record at least a minute to request an AI Review.',
    'Archetypes.SequenceHeading': 'Your archetype sequence',
    'Archetypes.SequenceModeAria': 'Sequence mode',
    'Archetypes.Signatures.Coach.DoNow.Fillers': 'Cut every filler word',
    'Archetypes.Signatures.Coach.DoNow.Inflection': 'Land each line on a downward beat',
    'Archetypes.Signatures.Coach.DoNow.Phrasing': 'Punch it staccato — short phrases',
    'Archetypes.Signatures.Coach.DoNow.Tonality': 'Stay direct and instructive',
    'Archetypes.Signatures.Coach.Role': 'HOW',
    'Archetypes.Signatures.Coach.Signature.Fillers': 'No filler words',
    'Archetypes.Signatures.Coach.Signature.Inflection': 'Confident downward inflection',
    'Archetypes.Signatures.Coach.Signature.Phrasing': 'Staccato — short, punchy phrases',
    'Archetypes.Signatures.Coach.Signature.Tonality': 'Direct, instructive tone',
    'Archetypes.Signatures.Coach.Tagline': 'Drive the action — crisp, direct, no wasted words.',
    'Archetypes.Signatures.Educator.DoNow.Articulation': 'Articulate every word precisely',
    'Archetypes.Signatures.Educator.DoNow.Pause': 'Pause to let each point land',
    'Archetypes.Signatures.Educator.DoNow.Pitch': 'Drop your pitch lower',
    'Archetypes.Signatures.Educator.DoNow.Rate': 'Slow to a deliberate, even pace',
    'Archetypes.Signatures.Educator.Role': 'WHAT',
    'Archetypes.Signatures.Educator.Signature.Articulation': 'Precise articulation',
    'Archetypes.Signatures.Educator.Signature.Pause': 'Pauses++ — let points land',
    'Archetypes.Signatures.Educator.Signature.Pitch': 'Lower pitch',
    'Archetypes.Signatures.Educator.Signature.Rate': 'Deliberate, even pace',
    'Archetypes.Signatures.Educator.Tagline': 'Deliver the content — clear, measured, easy to follow.',
    'Archetypes.Signatures.Friend.DoNow.Address': 'Speak as if to one person',
    'Archetypes.Signatures.Friend.DoNow.Pitch': 'Let your melody rise and fall',
    'Archetypes.Signatures.Friend.DoNow.Rate': 'Talk conversationally',
    'Archetypes.Signatures.Friend.DoNow.Tonality': 'Soften into a warm, open tone',
    'Archetypes.Signatures.Friend.Role': 'Connection',
    'Archetypes.Signatures.Friend.Signature.Address': 'Speak as if to one person',
    'Archetypes.Signatures.Friend.Signature.Pitch': 'Melody++ — let pitch rise and fall',
    'Archetypes.Signatures.Friend.Signature.Rate': 'Conversational pace',
    'Archetypes.Signatures.Friend.Signature.Tonality': 'Relaxed, open tone',
    'Archetypes.Signatures.Friend.Tagline': 'Open and close with warmth — talk with the room, not at it.',
    'Archetypes.Signatures.Motivator.DoNow.Energy': 'Build the energy as you go',
    'Archetypes.Signatures.Motivator.DoNow.Gesture': 'Gesture big with the whole body',
    'Archetypes.Signatures.Motivator.DoNow.Phrasing': 'Flow legato — smooth, connected phrases',
    'Archetypes.Signatures.Motivator.DoNow.Volume': 'Project — push the volume',
    'Archetypes.Signatures.Motivator.Role': 'WHY',
    'Archetypes.Signatures.Motivator.Signature.Energy': 'Rising intensity',
    'Archetypes.Signatures.Motivator.Signature.Gesture': 'Gestures++ — use the whole body',
    'Archetypes.Signatures.Motivator.Signature.Phrasing': 'Legato — smooth, flowing phrases',
    'Archetypes.Signatures.Motivator.Signature.Volume': 'Volume++ — project',
    'Archetypes.Signatures.Motivator.Tagline': 'Lift the energy — make the audience feel the reason it matters.',
    'Archetypes.StartCardCopy': 'When you are ready, the AI will generate a short story for you to read. Record yourself reading it and shift archetype each time a cue appears.',
    'Archetypes.StoryKindLabel': 'Story',
    'Archetypes.Title': 'Archetype · VoiceDojo',
    'Archetypes.VocalSignatureLabel': 'Vocal signature',
    'BodyLanguage.AbortBody': 'The AI guide gave up after three attempts. Your daily practice slot has been refunded.',
    'BodyLanguage.AbortHeading': 'We couldn’t generate your story',
    'BodyLanguage.Credit': 'Animated emoji: [Google Noto Animated Emoji](https://googlefonts.github.io/noto-emoji-animation/) (CC BY 4.0)',
    'BodyLanguage.DefaultStoryTitle': 'Your story',
    'BodyLanguage.ExplainAria': 'Explain {Technique}',
    'BodyLanguage.GenerateOfflineStart': 'Generate offline & start',
    'BodyLanguage.GenerateStoryStart': 'Generate a story & start',
    'BodyLanguage.GuideHeading': 'Body language guide',
    'BodyLanguage.GuideIntro': 'Tap any technique for a quick explanation, or untick it to leave that gesture out of the practice.',
    'BodyLanguage.Guides.EyeContact.Body': 'Eye contact builds connection and trust. Hold a gaze for a full thought rather than darting, then move on. With a camera, treat the lens as a single listener and look right down it on your key lines.',
    'BodyLanguage.Guides.EyeContact.Title': 'Eye Contact',
    'BodyLanguage.Guides.Facial.Body': 'The face carries emotion faster than words. Let your expression match the meaning of each line — a smile to warm, raised brows to surprise, a settled face to reassure. A mismatched face contradicts your message.',
    'BodyLanguage.Guides.Facial.Title': 'Facial Expression',
    'BodyLanguage.Guides.Gesture.Body': 'Gestures illustrate and emphasise. Placater (palms up, welcoming), Leveller (flat, calming chops), Blamer (a pointed finger for emphasis), Computer (still, precise, measured), Power Sphere (hands framing a sphere at your centre — the home base of confident gesture), Distractor (a deliberate pattern-break), and Advanced (layering gestures fluidly). Gesture in your own Power Sphere and return there between moves.',
    'BodyLanguage.Guides.Gesture.Title': 'Hand Gestures — the seven categories',
    'BodyLanguage.Guides.Movement.Body': 'Purposeful movement marks structure: step in to draw the audience close, hold still to anchor a key beat, cross the space to signal a new idea. Aimless pacing leaks nervous energy — every move should mean something.',
    'BodyLanguage.Guides.Movement.Title': 'Movement',
    'BodyLanguage.Guides.Posture.Body': 'Posture is the foundation of presence. Stack head over shoulders over hips, soften the knees, and let the chest stay open. A grounded, unforced stance reads as calm authority before you say a word.',
    'BodyLanguage.Guides.Posture.Title': 'Posture',
    'BodyLanguage.Heading': 'Body Language',
    'BodyLanguage.IncludeAria': 'Include {Technique} in the practice',
    'BodyLanguage.IntroCopy': 'Read the AI-generated story while body-gesture cues fire at random. It’s a playground — the cues need not track the story. Explore your whole physical instrument.',
    'BodyLanguage.Lead': 'AI generates a story to read aloud. While you record, live cues throw random prompts from the body-language vocabulary — posture resets, hand-gesture categories, facial expression, movement, and eye contact.',
    'BodyLanguage.MetaDescription': 'Body Language — practise posture, gestures, facial expression, and movement with random live cues.',
    'BodyLanguage.NewStory': 'New story',
    'BodyLanguage.NoGesturesSelected': 'Tick at least one technique to start.',
    'BodyLanguage.ResumeSession': 'Resume session',
    'BodyLanguage.ReviewTooltip': 'Record at least a minute to request an AI Review.',
    'BodyLanguage.StoryKindLabel': 'Story',
    'BodyLanguage.Title': 'Body Language · VoiceDojo',
    'Common.CustomTopic': 'Custom topic: {Topic}',
    'Common.DailyLimitReached': 'Daily practice limit reached — come back and play tomorrow.',
    'Common.DailyLimitReachedLogIn': 'Daily practice limit reached. [Log in]({Href}) for a higher daily allowance.',
    'Common.DownloadingModel': 'Downloading the model…',
    'Common.GeneratingStory': 'Generating your story…',
    'Common.LeaveStopConfirm': 'You\'re recording — leave and stop the take?',
    'Common.LoadingModel': 'Loading the model…',
    'Common.MasteryKicker': 'Mastery',
    'Common.MinSuffix': 'min',
    'Common.ModelUnavailable': 'Model unavailable — pick another',
    'Common.PauseRecording': 'Pause recording',
    'Common.PlaygroundKicker': 'Playground',
    'Common.PracticeLength': 'Practice length',
    'Common.PracticeLengthAria': 'Practice length in minutes',
    'Common.QuotaRemainingMany': '{Remaining} of {Limit} practice sessions left today.',
    'Common.QuotaRemainingOne': '{Remaining} of {Limit} practice session left today.',
    'Common.ResumeRecording': 'Resume recording',
    'Common.StartRecording': 'Start recording',
    'Common.StartRecordingAria': 'Start recording your take',
    'Common.TargetPace': 'Your target pace',
    'Common.TargetPaceAria': 'Target words per minute',
    'Common.TargetPaceHint': 'Conversational is around 130. Slower gives you room to shape each word.',
    'Common.TargetPaceOutOfRange': 'A readable pace runs between {Min} and {Max} wpm. This will settle at {Settled}.',
    'Common.TargetPaceUnit': 'wpm',
    'Common.TargetWordsFloorNote': '· held at the {Floor}-word floor',
    'Common.TargetWordsSummaryMany': 'Story will have **{Words}** words, roughly — {Wpm} wpm across {Minutes} minutes',
    'Common.TargetWordsSummaryOne': 'Story will have **{Words}** words, roughly — {Wpm} wpm across {Minutes} minute',
    'Common.TopicAnything': 'Leave blank for a surprise',
    'Common.TopicLabel': 'Topic',
    'Common.TryAgain': 'Try again',
    'Common.UseDefault': 'Use default',
    'Common.WritingStory': 'Writing your story…',
    'CueVisual.ArchetypeEnergy': 'Energy {Level} of 10',
    'CueVisual.Help': 'Help!',
    'CueVisual.HelpDone': 'That\'s all',
    'CueVisual.HelpIdle': 'Stuck? A nudge is one tap away.',
    'CueVisual.MixedFamily.Archetype': 'Archetype',
    'CueVisual.MixedFamily.Auditory': 'Voice',
    'CueVisual.MixedFamily.Help': 'Help',
    'CueVisual.MixedFamily.Visual': 'Body',
    'CueVisual.Nudge': 'Nudge {N} of {Total}',
    'CueVisual.Paused': 'Paused',
    'CueVisual.RiffHelp': 'Help: {Message}',
    'Instrument.AbortBody': 'The AI guide ran into trouble producing your story after three attempts. Your daily practice slot has been refunded, so it didn’t cost you a try.',
    'Instrument.AbortHeading': 'We couldn’t generate your practice',
    'Instrument.AiGuideLabel': 'AI guide',
    'Instrument.Encourage': 'That is the instrument. Every read is just play — try a key you dodged, or run it again with a different feeling.',
    'Instrument.ExplainKeyAria': 'Explain the {Key} key',
    'Instrument.ExplainTechniqueAria': 'Explain the {Key} technique',
    'Instrument.Heading': 'The Instrument',
    'Instrument.Keys.Pause.Guide': 'A pause is a note too. Silence before a key word creates anticipation; silence after it gives the idea room to breathe. Pauses also reset your pace and replace filler words. Do not fear the gap — own it. The room will wait for you.',
    'Instrument.Keys.Pause.Tagline': 'The power of silence.',
    'Instrument.Keys.Phrasing.Guide': 'Phrasing is how you join your words — or don’t. Legato runs them together into one unbroken line: warm, flowing, carrying you along. Staccato cuts them apart: short, punchy, decisive. It is a technique of its own, independent of speed and volume — you can race through a legato line, or punch out slow staccato. Play both ends of it on the same sentence and hear how differently it lands.',
    'Instrument.Keys.Phrasing.Tagline': 'Smooth and flowing, or short and punchy.',
    'Instrument.Keys.Pitch.Guide': 'Pitch is how high or low a note sits; melody is the tune your sentences trace. A flat, monotone line signals boredom. Let your pitch climb on a question, fall on a full stop, and dance in the middle — your voice should sing the meaning, not just say it.',
    'Instrument.Keys.Pitch.Tagline': 'The rise and fall of your voice.',
    'Instrument.Keys.Rate.Guide': 'Rate is your tempo. Speeding up builds energy and urgency; slowing down adds weight and lets a key idea land. Great speakers vary their rate constantly — a steady drone is the fastest way to lose a room. Play with it: race through a list, then crawl through the punchline.',
    'Instrument.Keys.Rate.Tagline': 'How fast or slow you speak.',
    'Instrument.Keys.Siren.Guide': 'The siren is a warm-up and a technique: glide your voice smoothly from your lowest comfortable note up to your highest and back, like a siren. It stretches your range and frees your pitch so melody comes easily. Sweep through the words — no steps, just one smooth glide.',
    'Instrument.Keys.Siren.Tagline': 'Glide smoothly through your whole vocal range.',
    'Instrument.Keys.Tonality.Guide': 'Tonality is the emotional colour you paint with — warm, playful, serious, tender, fierce. The same words can comfort or challenge depending on the tone. Decide how you want the listener to feel, then let that feeling soak into your voice.',
    'Instrument.Keys.Tonality.Tagline': 'The colour and emotion in your voice.',
    'Instrument.Keys.Volume.Guide': 'Volume is dynamics. A lift in volume commands attention; dropping to almost a whisper pulls listeners in and makes them lean closer. The contrast is what matters — not how loud you can get, but how freely you move between loud and soft.',
    'Instrument.Keys.Volume.Tagline': 'How loud or soft you are.',
    'Instrument.KeysHeading': 'The five keys',
    'Instrument.KeysIntro': 'Tap a key for the AI guide’s take on it. During the take, a cue will light the key up when it is time to play with it.',
    'Instrument.Lead': 'Your voice has 88 keys. Read an AI-written story aloud while live cues invite you to play — speak faster, drop your volume, siren now, smile. There is no score here: it is a playground. Just explore.',
    'Instrument.MetaDescription': 'The Instrument — explore your voice as an 88-key instrument: Rate, Volume, Pitch & Melody, Tonality, Pause, Phrasing, Siren and facial expression, with live AI cues.',
    'Instrument.ResumePlaygroundAria': 'Resume the playground',
    'Instrument.ResumePlaying': 'Resume playing',
    'Instrument.ReviewTooltip': 'Record at least a minute to request an AI Review.',
    'Instrument.StartOffline': 'Start playing (offline)',
    'Instrument.StartPlaygroundAria': 'Start the playground',
    'Instrument.StartPlaying': 'Start playing',
    'Instrument.TechniquesHeading': 'Plus two techniques',
    'Instrument.Title': 'The Instrument · VoiceDojo',
    'OffBook.AbortHeading': 'We couldn’t rewrite your story',
    'OffBook.AddStoryFirst': 'Add your story first',
    'OffBook.AmsDescription': 'Analogy, metaphor, simile.',
    'OffBook.DefaultStoryTitle': 'Your story',
    'OffBook.EnrichLegend': 'Enrich with',
    'OffBook.EnrichOptional': '(optional)',
    'OffBook.FrameworkAria': 'Structural framework',
    'OffBook.FrameworkStorytellingFormula': 'Storytelling Formula',
    'OffBook.GuideHeading': 'Off book — your story, your shape',
    'OffBook.GuideHint': 'Bring a story you want to tell. The AI rewrites and expands it into the shape you choose and sizes it to your target length, then runs it as a guided read-aloud with live cues. Once you\'re warm, hide the story and the cues and go fully off book.',
    'OffBook.HideCues': 'Hide cues',
    'OffBook.HideStory': 'Hide story',
    'OffBook.NewStory': 'New story',
    'OffBook.ReadyHint': 'Your story is ready. Start recording when you are — read it aloud and follow the cues.',
    'OffBook.ReviewTooltip': 'Record at least a minute to request an AI Review.',
    'OffBook.RewriteRehearse': 'Rewrite & rehearse',
    'OffBook.RewritingStory': 'Rewriting your story…',
    'OffBook.ShapeLegend': 'Shape it with',
    'OffBook.StartRecording': 'Start recording',
    'OffBook.Step1Heading': '1 · Bring your story',
    'OffBook.Step2Heading': '2 · Rehearse your take',
    'OffBook.StoryKindLabel': 'Story',
    'OffBook.StoryLabel': 'Your story',
    'OffBook.StoryPlaceholder': 'Paste or type the story you want to tell…',
    'OffBook.TakeLengthAria': 'Take length in minutes',
    'OffBook.TakeLengthHint': 'A full 5–15 minute take',
    'OffBook.TakeLengthLabel': 'Take length',
    'OffBook.TellingEyebrow': 'Telling',
    'OffBook.VaksDescription': 'Sensory richness — visual, auditory, kinesthetic, smell-taste.',
    'OffBook.WithCuesAria': 'Practice with cues',
    'OffBook.WithCuesHint': 'Live, context-aware cues across voice, body, gesture and archetype.',
    'OffBook.WithCuesLabel': 'Practice with cues',
    'Storytelling.AbortHeading': 'We couldn’t generate your topic',
    'Storytelling.AmsDescription': 'Analogy, metaphor, simile.',
    'Storytelling.DefaultTopicTitle': 'Your topic',
    'Storytelling.EnrichLegend': 'Enrich the help cues with',
    'Storytelling.EnrichOptional': '(optional)',
    'Storytelling.FrameworkAria': 'Structural framework',
    'Storytelling.FrameworkStorytellingFormula': 'Storytelling Formula',
    'Storytelling.Heading': 'Storytelling',
    'Storytelling.Lead': 'Talk for 3–15 minutes on a topic and record a full take. Get an AI Review of your structure and delivery afterwards.',
    'Storytelling.MetaDescription': 'Storytelling — record a full 3–15 minute take built on the Storytelling Formula and VAKS sensory detail, then get an AI Review.',
    'Storytelling.ModeAria': 'Storytelling mode',
    'Storytelling.ModeImprov': 'Improv',
    'Storytelling.ModeLockedAria': 'Finish your take to switch modes',
    'Storytelling.ModeOffBook': 'Off-Book',
    'Storytelling.NewTopic': 'New topic',
    'Storytelling.NoExtraLenses': 'no extra lenses',
    'Storytelling.ReviewTooltip': 'Record at least a minute to request an AI Review.',
    'Storytelling.SetupAria': 'Set up your story',
    'Storytelling.ShapeHeading': 'Shape & help cues',
    'Storytelling.ShapeLegend': 'Shape it with',
    'Storytelling.SpineTitle': 'Your roadmap',
    'Storytelling.StartRecording': 'Start recording',
    'Storytelling.StartSession': 'Get my roadmap',
    'Storytelling.TakeLengthAria': 'Take length in minutes',
    'Storytelling.TakeLengthLabel': 'Take length',
    'Storytelling.TellingEyebrow': 'Telling',
    'Storytelling.Title': 'Storytelling · VoiceDojo',
    'Storytelling.TopicKindLabel': 'Topic',
    'Storytelling.TopicLegend': 'Your topic',
    'Storytelling.TopicMoreIdeas': 'More ideas',
    'Storytelling.TopicPlaceholder': 'Leave blank and we’ll pick one for you',
    'Storytelling.TopicSuggestionsLabel': 'Try:',
    'Storytelling.VaksDescription': 'Sensory richness — visual, auditory, kinesthetic, smell-taste.',
    'Storytelling.WritingTopic': 'Setting up your topic…',
    'WordPlay.AbortBody': 'The AI guide gave up after three attempts. Your daily practice slot has been refunded.',
    'WordPlay.AbortHeading': 'We couldn’t pick your word',
    'WordPlay.DownloadHelpHeading': 'Help cues you revealed:',
    'WordPlay.DownloadWordPrefix': 'Word: {Word}',
    'WordPlay.GuideAria': 'Riff guide',
    'WordPlay.GuideCopy': 'You get a single English word. Speak about it freely for 1-5 minutes — anything goes: a memory, a description, a story, a tangent. If you stall, tap **I need help!** and the AI will reveal a prompt to keep you going. There are no “right” answers — it’s a playground, not a test.',
    'WordPlay.GuideHeading': 'How Riff works',
    'WordPlay.Heading': 'Riff',
    'WordPlay.HelpPromptsHint': '{Count} help prompts are ready for a take this long.',
    'WordPlay.IntroCopy': 'Pick how long you’d like to speak, then click **Start riffing**.',
    'WordPlay.Lead': 'Improvise on a single word.',
    'WordPlay.MetaDescription': 'Riff — one-word improvisation. Get a word, speak for 1-5 minutes, tap “I need help!” if you stall.',
    'WordPlay.NewWord': 'New word',
    'WordPlay.PickingWord': 'Picking your word…',
    'WordPlay.ResumeSession': 'Resume session',
    'WordPlay.StartRiffing': 'Start riffing',
    'WordPlay.Title': 'Riff · VoiceDojo',
    'WordPlay.WebGpuRequired': 'Offline mode needs WebGPU for its in-browser model, and this browser has none — Riff still works online. To practise offline, try a recent Chrome, Edge, or Firefox 141+.',
    'WordPlay.WordKindLabel': 'Word',
    'WordPlay.YourWordEyebrow': 'Your word',
  },
  'vi-VN': {
    'ActiveListening.DefaultSpeakerTitle': 'Người nói',
    'ActiveListening.Demo.Note': 'Đây là ví dụ về cả hai cách luyện — người nói và lời thoại mẫu, không phải bản ghi thật.',
    'ActiveListening.Demo.SpeakerName': 'Maya',
    'ActiveListening.Demo.SpeakerOne': 'Chủ nhật vừa rồi tôi chạy bán marathon đầu tiên. Đến khoảng dặm thứ mười thì chân tôi không chịu nghe lời nữa.',
    'ActiveListening.Demo.SpeakerThree': 'Rồi em gái tôi nhảy ra từ đám đông và chạy dặm cuối cùng cùng tôi — vẫn đang mặc quần jeans.',
    'ActiveListening.Demo.SpeakerTitle': 'Dặm cuối cùng',
    'ActiveListening.Demo.SpeakerTwo': 'Tôi phải đi bộ một đoạn, và thật lòng mà nói, tôi suýt bỏ cuộc ngay lúc đó.',
    'ActiveListening.Demo.YouOne': 'Vậy là bạn suýt bỏ cuộc ở dặm thứ mười, và em gái đã đưa bạn về đích.',
    'ActiveListening.Demo.YouTwo': 'Giọng bạn trầm xuống khi kể đoạn đi bộ, rồi vút lên khi em ấy xuất hiện. Nghe bạn vừa tự hào — vừa xúc động vì có em ấy ở đó.',
    'ActiveListening.GateGuest': 'Luyện lắng nghe với một người nói AI. Phản hồi lại câu chuyện của họ, hoặc trò chuyện trực tiếp và được nhận xét bằng lời.',
    'ActiveListening.GateOutOfCredits': 'Bạn đã hết tín dụng AI. Hãy thêm tín dụng để bắt đầu một buổi luyện.',
    'ActiveListening.GenerateFailed': 'Không tạo được người nói. Vui lòng thử lại.',
    'ActiveListening.GenerateSpeaker': 'Tạo người nói AI',
    'ActiveListening.GenerateTimedOut': 'Tạo người nói mất quá lâu. Vui lòng thử lại.',
    'ActiveListening.Generating': 'Đang tạo…',
    'ActiveListening.Guide.AvoidHeading': 'Tránh',
    'ActiveListening.Guide.Heading': 'Phản hồi lại',
    'ActiveListening.Guide.Intro': 'Bạn vừa nghe một người kể chuyện. Giờ hãy nói với họ như thể họ đang ở ngay trước mặt bạn, kể lại những gì bạn đã tiếp nhận — để họ cảm thấy được **lắng nghe**.',
    'ActiveListening.Guide.Lanes.Body': '**Ngôn ngữ cơ thể** — bạn chỉ nghe thấy họ, nên hãy hình dung từ giọng nói. *“I picture you …”*',
    'ActiveListening.Guide.Lanes.Content': '**Nội dung** — điều họ kể, theo lời của bạn. *“So what happened was…”*',
    'ActiveListening.Guide.Lanes.Mood': '**Tâm trạng & cảm xúc** — gọi tên điều họ cảm thấy. *“You sound …”*',
    'ActiveListening.Guide.Lanes.Vocal': '**Thay đổi giọng nói** — chỗ giọng họ thay đổi. *“When you said …, your voice …”*',
    'ActiveListening.Guide.Traps.Advising': '**Khuyên bảo** — *“What you should do is…”*',
    'ActiveListening.Guide.Traps.Judging': '**Phán xét** — *“You shouldn\'t have…”*',
    'ActiveListening.Guide.Traps.MindReading': '**Đoán ý** — *“What you really mean is…”*',
    'ActiveListening.Guide.Traps.OneUpping': '**Hơn thua** — *“That\'s nothing, once I…”*',
    'ActiveListening.Heading': 'Lắng nghe chủ động',
    'ActiveListening.HideTranscript': 'Ẩn bản ghi lời',
    'ActiveListening.Lead': 'Một AI đóng vai người nói. Hãy lắng nghe, rồi phản hồi lại nội dung, tâm trạng, giọng nói và ngôn ngữ cơ thể của họ, không phán xét hay khuyên bảo.',
    'ActiveListening.MetaDescription': 'Lắng nghe chủ động — luyện phản hồi lại nội dung, tâm trạng, thay đổi giọng nói và ngôn ngữ cơ thể với một người nói AI.',
    'ActiveListening.ModeHeading': 'Bạn muốn luyện thế nào?',
    'ActiveListening.ModeLabel': 'Chế độ Lắng nghe chủ động',
    'ActiveListening.ModeLive': 'Trò chuyện trực tiếp',
    'ActiveListening.ModeLiveHint': 'Trò chuyện thời gian thực với một người nói AI, người kể chuyện và phản ứng theo cách bạn phản hồi lại.',
    'ActiveListening.ModeLiveNoteFeedback': 'Cuộc trò chuyện kết thúc bằng nhận xét bằng giọng nói về cách bạn lắng nghe.',
    'ActiveListening.ModeLiveNoteHeadphones': 'Hãy đeo tai nghe, để AI không nghe thấy chính mình và ngắt lời.',
    'ActiveListening.ModeRespond': 'Nghe & phản hồi',
    'ActiveListening.ModeRespondHint': 'Một người nói AI kể cho bạn một câu chuyện ngắn; bạn nghe, rồi ghi âm phần phản hồi lại của mình.',
    'ActiveListening.ModeRespondNoteReplay': 'Bạn có thể nghe lại người nói bao nhiêu lần tùy thích trước khi ghi.',
    'ActiveListening.ModeRespondNoteReview': 'Gửi bản ghi để AI Review nhận xét bạn phản hồi lại tốt đến đâu.',
    'ActiveListening.PractiseAgain': 'Luyện lại',
    'ActiveListening.ReviewTooltip': 'Hãy ghi ít nhất một phút để yêu cầu AI đánh giá.',
    'ActiveListening.SessionStartFailed': 'Không bắt đầu được phần phản hồi của bạn. Vui lòng thử lại.',
    'ActiveListening.ShowTranscript': 'Hiện bản ghi lời',
    'ActiveListening.SpeakerCostMany': 'Tạo người nói tốn {Credits} tín dụng AI.',
    'ActiveListening.SpeakerCostOne': 'Tạo người nói tốn {Credits} tín dụng AI.',
    'ActiveListening.SpeakerHeading': 'Người nói · {Title}',
    'ActiveListening.SpeakerVoiceUnavailable': 'Giọng người nói AI hiện không khả dụng. Vui lòng thử lại sau.',
    'ActiveListening.Step1Copy': 'Tạo một đoạn nói ngắn. Phát lại bao nhiêu lần bạn cần — chú ý không chỉ từ ngữ, mà cả tâm trạng và cách truyền đạt.',
    'ActiveListening.Step1Heading': '1 · Lắng nghe người nói',
    'ActiveListening.Step2Copy': 'Phát lại người nói bao nhiêu lần tùy bạn, rồi tự ghi lại phần phản hồi của mình — hướng dẫn bên dưới chỉ cách làm.',
    'ActiveListening.Title': 'Lắng nghe chủ động · VoiceDojo',
    'ActiveListening.WritingPassage': 'Đang viết đoạn người nói của bạn…',
    'Archetypes.AbortBody': 'Hướng dẫn AI đã bỏ cuộc sau ba lần thử. Lượt luyện tập trong ngày của bạn đã được hoàn lại.',
    'Archetypes.AbortHeading': 'Chúng tôi không tạo được câu chuyện của bạn',
    'Archetypes.AddShift': '+ Thêm lần chuyển',
    'Archetypes.BookendTitle': 'Mỏ neo Kết nối — luôn bật',
    'Archetypes.ClassicHint': 'Cung mặc định mở và đóng bằng Người bạn — Kết nối → TẠI SAO → CÁI GÌ → LÀM SAO → Kết nối. Sắp xếp lại các bước, ngẫu nhiên hóa phần giữa, hoặc bỏ chọn một nguyên mẫu để loại nó khỏi luồng luyện tập.',
    'Archetypes.DefaultStoryTitle': 'Câu chuyện của bạn',
    'Archetypes.ExplainFriendAria': 'Giải thích đặc trưng giọng nói của Người bạn',
    'Archetypes.ExplainSignatureAria': 'Giải thích đặc trưng giọng nói của {Archetype}',
    'Archetypes.GenerateOfflineStart': 'Tạo ngoại tuyến & bắt đầu',
    'Archetypes.GenerateStoryStart': 'Tạo câu chuyện & bắt đầu',
    'Archetypes.GuideTitle': 'Hướng dẫn nguyên mẫu',
    'Archetypes.Heading': 'Nguyên mẫu',
    'Archetypes.IncludeAria': 'Đưa {Archetype} vào bài luyện',
    'Archetypes.Lead': 'Luyện chuyển đổi qua bốn nguyên mẫu giọng nói — Người bạn, Người truyền cảm hứng, Người dạy, Huấn luyện viên. AI viết một câu chuyện để bạn đọc trong khi các gợi ý trực tiếp nhắc mỗi lần chuyển.',
    'Archetypes.MetaDescription': 'Nguyên mẫu — luyện chuyển đổi qua các nguyên mẫu giọng nói Người bạn, Người truyền cảm hứng, Người dạy và Huấn luyện viên.',
    'Archetypes.MixCount': '{Count} lần chuyển (tối đa {Max} cho {Minutes} phút)',
    'Archetypes.MixHint': 'Tự dựng cung của bạn — Người bạn mở và đóng nó, và không có hai lần chuyển liền nhau lặp lại cùng một nguyên mẫu. Thêm, bớt, sắp xếp lại hoặc ngẫu nhiên hóa phần giữa. Với bản thu {Minutes} phút bạn có thể chạy tối đa {MaxShifts} lần chuyển (mỗi lần giữ 10–60 giây).',
    'Archetypes.MixInvalid': 'Hãy thêm ít nhất 5 lần chuyển sao cho không có hai lần liền nhau lặp lại cùng một nguyên mẫu.',
    'Archetypes.ModeClassic': 'Thang cổ điển',
    'Archetypes.ModeMixMatch': 'Phối tự do',
    'Archetypes.Randomise': 'Ngẫu nhiên',
    'Archetypes.RemoveShiftAria': 'Bỏ lần chuyển {Archetype}',
    'Archetypes.ReorderAria': 'Sắp xếp lại {Archetype}',
    'Archetypes.Reset': 'Đặt lại',
    'Archetypes.ResumeSession': 'Tiếp tục phiên',
    'Archetypes.ReviewTooltip': 'Hãy ghi ít nhất một phút để yêu cầu AI đánh giá.',
    'Archetypes.SequenceHeading': 'Chuỗi nguyên mẫu của bạn',
    'Archetypes.SequenceModeAria': 'Chế độ chuỗi',
    'Archetypes.Signatures.Coach.DoNow.Fillers': 'Cắt sạch mọi từ đệm',
    'Archetypes.Signatures.Coach.DoNow.Inflection': 'Kết mỗi câu bằng một nhịp đi xuống',
    'Archetypes.Signatures.Coach.DoNow.Phrasing': 'Dứt khoát kiểu staccato — câu thật ngắn',
    'Archetypes.Signatures.Coach.DoNow.Tonality': 'Giữ giọng thẳng thắn và chỉ dẫn',
    'Archetypes.Signatures.Coach.Role': 'LÀM SAO',
    'Archetypes.Signatures.Coach.Signature.Fillers': 'Không có từ đệm',
    'Archetypes.Signatures.Coach.Signature.Inflection': 'Ngữ điệu đi xuống đầy tự tin',
    'Archetypes.Signatures.Coach.Signature.Phrasing': 'Staccato — câu ngắn, dứt khoát',
    'Archetypes.Signatures.Coach.Signature.Tonality': 'Tông thẳng thắn, chỉ dẫn',
    'Archetypes.Signatures.Coach.Tagline': 'Thúc đẩy hành động — gọn, thẳng, không thừa chữ.',
    'Archetypes.Signatures.Educator.DoNow.Articulation': 'Phát âm từng chữ thật chuẩn xác',
    'Archetypes.Signatures.Educator.DoNow.Pause': 'Ngừng lại để mỗi ý lắng xuống',
    'Archetypes.Signatures.Educator.DoNow.Pitch': 'Hạ cao độ xuống thấp hơn',
    'Archetypes.Signatures.Educator.DoNow.Rate': 'Chậm lại thành một nhịp thong thả, đều đặn',
    'Archetypes.Signatures.Educator.Role': 'CÁI GÌ',
    'Archetypes.Signatures.Educator.Signature.Articulation': 'Phát âm chuẩn xác',
    'Archetypes.Signatures.Educator.Signature.Pause': 'Khoảng lặng++ — để các ý lắng xuống',
    'Archetypes.Signatures.Educator.Signature.Pitch': 'Cao độ trầm hơn',
    'Archetypes.Signatures.Educator.Signature.Rate': 'Nhịp thong thả, đều đặn',
    'Archetypes.Signatures.Educator.Tagline': 'Truyền đạt nội dung — rõ ràng, chừng mực, dễ theo dõi.',
    'Archetypes.Signatures.Friend.DoNow.Address': 'Nói như thể với một người',
    'Archetypes.Signatures.Friend.DoNow.Pitch': 'Để giai điệu của bạn lên xuống',
    'Archetypes.Signatures.Friend.DoNow.Rate': 'Nói như đang trò chuyện',
    'Archetypes.Signatures.Friend.DoNow.Tonality': 'Dịu lại thành một tông ấm áp, cởi mở',
    'Archetypes.Signatures.Friend.Role': 'Kết nối',
    'Archetypes.Signatures.Friend.Signature.Address': 'Nói như thể với một người',
    'Archetypes.Signatures.Friend.Signature.Pitch': 'Giai điệu++ — để cao độ lên xuống',
    'Archetypes.Signatures.Friend.Signature.Rate': 'Nhịp trò chuyện',
    'Archetypes.Signatures.Friend.Signature.Tonality': 'Tông thư thái, cởi mở',
    'Archetypes.Signatures.Friend.Tagline': 'Mở và đóng bằng sự ấm áp — nói cùng cả phòng, chứ không nói vào cả phòng.',
    'Archetypes.Signatures.Motivator.DoNow.Energy': 'Dồn năng lượng lên dần khi bạn nói',
    'Archetypes.Signatures.Motivator.DoNow.Gesture': 'Làm cử chỉ lớn bằng cả cơ thể',
    'Archetypes.Signatures.Motivator.DoNow.Phrasing': 'Chảy legato — câu mượt mà, liền mạch',
    'Archetypes.Signatures.Motivator.DoNow.Volume': 'Bật giọng ra — đẩy âm lượng lên',
    'Archetypes.Signatures.Motivator.Role': 'TẠI SAO',
    'Archetypes.Signatures.Motivator.Signature.Energy': 'Cường độ tăng dần',
    'Archetypes.Signatures.Motivator.Signature.Gesture': 'Cử chỉ++ — dùng cả cơ thể',
    'Archetypes.Signatures.Motivator.Signature.Phrasing': 'Legato — câu mượt mà, liền mạch',
    'Archetypes.Signatures.Motivator.Signature.Volume': 'Âm lượng++ — bật giọng ra',
    'Archetypes.Signatures.Motivator.Tagline': 'Nâng năng lượng lên — để người nghe cảm được lý do điều này quan trọng.',
    'Archetypes.StartCardCopy': 'Khi bạn sẵn sàng, AI sẽ tạo một câu chuyện ngắn để bạn đọc. Hãy tự ghi lại khi đọc và chuyển nguyên mẫu mỗi khi một gợi ý xuất hiện.',
    'Archetypes.StoryKindLabel': 'Câu chuyện',
    'Archetypes.Title': 'Nguyên mẫu · VoiceDojo',
    'Archetypes.VocalSignatureLabel': 'Đặc trưng giọng nói',
    'BodyLanguage.AbortBody': 'Hướng dẫn AI đã bỏ cuộc sau ba lần thử. Lượt luyện tập trong ngày của bạn đã được hoàn lại.',
    'BodyLanguage.AbortHeading': 'Chúng tôi không tạo được câu chuyện của bạn',
    'BodyLanguage.Credit': 'Biểu tượng cảm xúc động: [Google Noto Animated Emoji](https://googlefonts.github.io/noto-emoji-animation/) (CC BY 4.0)',
    'BodyLanguage.DefaultStoryTitle': 'Câu chuyện của bạn',
    'BodyLanguage.ExplainAria': 'Giải thích {Technique}',
    'BodyLanguage.GenerateOfflineStart': 'Tạo ngoại tuyến & bắt đầu',
    'BodyLanguage.GenerateStoryStart': 'Tạo câu chuyện & bắt đầu',
    'BodyLanguage.GuideHeading': 'Hướng dẫn ngôn ngữ cơ thể',
    'BodyLanguage.GuideIntro': 'Chạm vào bất kỳ kỹ thuật nào để xem giải thích nhanh, hoặc bỏ chọn để loại cử chỉ đó khỏi bài luyện.',
    'BodyLanguage.Guides.EyeContact.Body': 'Giao tiếp bằng mắt xây dựng kết nối và niềm tin. Hãy giữ ánh nhìn trọn một ý thay vì đảo mắt liên tục, rồi chuyển sang người khác. Với máy quay, hãy coi ống kính như một người nghe duy nhất và nhìn thẳng vào đó ở những câu quan trọng.',
    'BodyLanguage.Guides.EyeContact.Title': 'Giao tiếp bằng mắt',
    'BodyLanguage.Guides.Facial.Body': 'Khuôn mặt truyền cảm xúc nhanh hơn lời nói. Hãy để biểu cảm khớp với ý nghĩa của từng câu — một nụ cười để làm ấm, nhướn mày để bất ngờ, gương mặt lắng lại để trấn an. Một khuôn mặt lệch pha sẽ phản lại thông điệp của bạn.',
    'BodyLanguage.Guides.Facial.Title': 'Biểu cảm khuôn mặt',
    'BodyLanguage.Guides.Gesture.Body': 'Cử chỉ để minh họa và nhấn mạnh. Người xoa dịu (Placater — ngửa lòng bàn tay, mời gọi), Người cân bằng (Leveller — bàn tay phẳng, chặt nhẹ trấn an), Người quy trách (Blamer — một ngón tay chỉ để nhấn mạnh), Người máy tính (Computer — bất động, chính xác, chừng mực), Quả Cầu Quyền Lực (Power Sphere — hai tay ôm một quả cầu trước thân, vị trí gốc của cử chỉ tự tin), Người gây nhiễu (Distractor — một cú phá nhịp có chủ ý), và Nâng cao (Advanced — xếp lớp các cử chỉ thật mượt). Hãy làm cử chỉ trong Quả Cầu Quyền Lực của riêng bạn và quay về đó giữa các động tác.',
    'BodyLanguage.Guides.Gesture.Title': 'Cử chỉ tay — bảy nhóm',
    'BodyLanguage.Guides.Movement.Body': 'Chuyển động có chủ đích đánh dấu cấu trúc: bước tới để kéo người nghe lại gần, đứng yên để neo một nhịp then chốt, băng qua không gian để báo hiệu một ý mới. Đi tới đi lui vô định làm rò rỉ sự bồn chồn — mỗi bước đi đều nên có ý nghĩa.',
    'BodyLanguage.Guides.Movement.Title': 'Chuyển động',
    'BodyLanguage.Guides.Posture.Body': 'Tư thế là nền móng của sự hiện diện. Xếp đầu trên vai, vai trên hông, thả lỏng đầu gối, và giữ lồng ngực mở. Một tư thế vững chãi, không gồng đọc lên như sự điềm tĩnh đầy uy lực trước cả khi bạn nói một lời.',
    'BodyLanguage.Guides.Posture.Title': 'Tư thế',
    'BodyLanguage.Heading': 'Ngôn ngữ cơ thể',
    'BodyLanguage.IncludeAria': 'Đưa {Technique} vào bài luyện',
    'BodyLanguage.IntroCopy': 'Đọc câu chuyện do AI tạo trong khi các gợi ý cử chỉ cơ thể xuất hiện ngẫu nhiên. Đây là một sân chơi — các gợi ý không cần bám theo câu chuyện. Hãy khám phá toàn bộ nhạc cụ thể chất của bạn.',
    'BodyLanguage.Lead': 'AI tạo một câu chuyện để đọc to. Trong khi bạn ghi, các gợi ý trực tiếp đưa ra lời nhắc ngẫu nhiên từ vốn ngôn ngữ cơ thể — chỉnh lại tư thế, các nhóm cử chỉ tay, biểu cảm khuôn mặt, chuyển động và giao tiếp bằng mắt.',
    'BodyLanguage.MetaDescription': 'Ngôn ngữ cơ thể — luyện tư thế, cử chỉ, biểu cảm khuôn mặt và chuyển động với các gợi ý trực tiếp ngẫu nhiên.',
    'BodyLanguage.NewStory': 'Câu chuyện mới',
    'BodyLanguage.NoGesturesSelected': 'Hãy chọn ít nhất một kỹ thuật để bắt đầu.',
    'BodyLanguage.ResumeSession': 'Tiếp tục phiên',
    'BodyLanguage.ReviewTooltip': 'Hãy ghi ít nhất một phút để yêu cầu AI đánh giá.',
    'BodyLanguage.StoryKindLabel': 'Câu chuyện',
    'BodyLanguage.Title': 'Ngôn ngữ cơ thể · VoiceDojo',
    'Common.CustomTopic': 'Chủ đề tùy chỉnh: {Topic}',
    'Common.DailyLimitReached': 'Đã đạt giới hạn luyện tập hằng ngày — hãy quay lại chơi vào ngày mai.',
    'Common.DailyLimitReachedLogIn': 'Đã đạt giới hạn luyện tập hằng ngày. [Đăng nhập]({Href}) để có hạn mức hằng ngày cao hơn.',
    'Common.DownloadingModel': 'Đang tải mô hình…',
    'Common.GeneratingStory': 'Đang tạo câu chuyện của bạn…',
    'Common.LeaveStopConfirm': 'Bạn đang ghi — rời đi và dừng bản thu?',
    'Common.LoadingModel': 'Đang nạp mô hình…',
    'Common.MasteryKicker': 'Tinh thông',
    'Common.MinSuffix': 'phút',
    'Common.ModelUnavailable': 'Mô hình không khả dụng — hãy chọn cái khác',
    'Common.PauseRecording': 'Tạm dừng ghi',
    'Common.PlaygroundKicker': 'Sân chơi',
    'Common.PracticeLength': 'Thời lượng luyện tập',
    'Common.PracticeLengthAria': 'Thời lượng luyện tập tính bằng phút',
    'Common.QuotaRemainingMany': 'Còn {Remaining} trên {Limit} lượt luyện hôm nay.',
    'Common.QuotaRemainingOne': 'Còn {Remaining} trên {Limit} lượt luyện hôm nay.',
    'Common.ResumeRecording': 'Tiếp tục ghi',
    'Common.StartRecording': 'Bắt đầu ghi',
    'Common.StartRecordingAria': 'Bắt đầu ghi phần trình bày của bạn',
    'Common.TargetPace': 'Tốc độ nói mục tiêu',
    'Common.TargetPaceAria': 'Số từ mỗi phút mục tiêu',
    'Common.TargetPaceHint': 'Tốc độ trò chuyện khoảng 130. Chậm hơn cho bạn thêm chỗ để nhấn từng chữ.',
    'Common.TargetPaceOutOfRange': 'Tốc độ đọc được nằm trong khoảng {Min} đến {Max} từ/phút. Giá trị này sẽ về {Settled}.',
    'Common.TargetPaceUnit': 'từ/phút',
    'Common.TargetWordsFloorNote': '· giữ ở mức sàn {Floor} từ',
    'Common.TargetWordsSummaryMany': 'Câu chuyện sẽ có **{Words}** từ, khoảng chừng — {Wpm} từ/phút trong {Minutes} phút',
    'Common.TargetWordsSummaryOne': 'Câu chuyện sẽ có **{Words}** từ, khoảng chừng — {Wpm} từ/phút trong {Minutes} phút',
    'Common.TopicAnything': 'Để trống để nhận một bất ngờ',
    'Common.TopicLabel': 'Chủ đề',
    'Common.TryAgain': 'Thử lại',
    'Common.UseDefault': 'Dùng mặc định',
    'Common.WritingStory': 'Đang viết câu chuyện của bạn…',
    'CueVisual.ArchetypeEnergy': 'Năng lượng {Level} trên 10',
    'CueVisual.Help': 'Giúp với!',
    'CueVisual.HelpDone': 'Hết rồi',
    'CueVisual.HelpIdle': 'Bí ý? Một gợi ý chỉ cách một lần chạm.',
    'CueVisual.MixedFamily.Archetype': 'Nguyên mẫu',
    'CueVisual.MixedFamily.Auditory': 'Giọng nói',
    'CueVisual.MixedFamily.Help': 'Trợ giúp',
    'CueVisual.MixedFamily.Visual': 'Cơ thể',
    'CueVisual.Nudge': 'Gợi ý {N}/{Total}',
    'CueVisual.Paused': 'Đã tạm dừng',
    'CueVisual.RiffHelp': 'Trợ giúp: {Message}',
    'Instrument.AbortBody': 'Hướng dẫn AI gặp trục trặc khi tạo câu chuyện sau ba lần thử. Lượt luyện tập trong ngày của bạn đã được hoàn lại, nên nó không tốn của bạn lượt nào.',
    'Instrument.AbortHeading': 'Chúng tôi không tạo được bài luyện của bạn',
    'Instrument.AiGuideLabel': 'Hướng dẫn AI',
    'Instrument.Encourage': 'Đó chính là nhạc cụ. Mỗi lần đọc chỉ là chơi đùa — thử một phím bạn đã né, hoặc chạy lại với một cảm xúc khác.',
    'Instrument.ExplainKeyAria': 'Giải thích phím {Key}',
    'Instrument.ExplainTechniqueAria': 'Giải thích kỹ thuật {Key}',
    'Instrument.Heading': 'Nhạc cụ',
    'Instrument.Keys.Pause.Guide': 'Khoảng lặng cũng là một nốt nhạc. Im lặng trước một từ then chốt tạo sự chờ đợi; im lặng sau đó cho ý tưởng khoảng trống để thở. Khoảng lặng cũng đặt lại nhịp của bạn và thay thế các từ đệm. Đừng sợ khoảng trống — hãy làm chủ nó. Cả phòng sẽ chờ bạn.',
    'Instrument.Keys.Pause.Tagline': 'Sức mạnh của sự im lặng.',
    'Instrument.Keys.Phrasing.Guide': 'Cách nhả chữ là việc bạn nối các chữ lại với nhau — hay không. Legato chảy liền thành một dòng không đứt: ấm, mượt, cuốn người nghe đi theo. Staccato cắt rời từng chữ: ngắn, gọn, dứt khoát. Đây là một kỹ thuật riêng, độc lập với tốc độ và âm lượng — bạn có thể phóng thật nhanh mà vẫn legato, hoặc bật staccato thật chậm. Hãy chơi cả hai đầu của nó trên cùng một câu và nghe xem chúng rơi xuống khác nhau thế nào.',
    'Instrument.Keys.Phrasing.Tagline': 'Mượt mà liền mạch, hay ngắn gọn dứt khoát.',
    'Instrument.Keys.Pitch.Guide': 'Cao độ là việc một nốt nằm cao hay thấp; giai điệu là đường nét mà các câu của bạn vẽ ra. Một đường phẳng, đều đều báo hiệu sự buồn chán. Hãy để cao độ leo lên ở câu hỏi, rơi xuống ở dấu chấm, và nhảy múa ở khoảng giữa — giọng bạn nên hát lên ý nghĩa, chứ không chỉ nói ra nó.',
    'Instrument.Keys.Pitch.Tagline': 'Sự lên xuống trong giọng của bạn.',
    'Instrument.Keys.Rate.Guide': 'Tốc độ là nhịp của bạn. Nói nhanh hơn tạo năng lượng và sự cấp bách; nói chậm lại thêm sức nặng và để một ý quan trọng lắng xuống. Người nói giỏi thay đổi tốc độ liên tục — một giọng đều đều là cách nhanh nhất để mất cả phòng. Hãy chơi với nó: lướt thật nhanh qua một danh sách, rồi bò chầm chậm qua câu chốt.',
    'Instrument.Keys.Rate.Tagline': 'Bạn nói nhanh hay chậm.',
    'Instrument.Keys.Siren.Guide': 'Siren vừa là bài khởi động vừa là một kỹ thuật: lướt giọng thật mượt từ nốt thấp nhất bạn thấy thoải mái lên nốt cao nhất rồi quay trở lại, như một tiếng còi. Nó kéo giãn quãng giọng và giải phóng cao độ để giai điệu đến thật dễ dàng. Hãy quét qua các từ — không đi từng bậc, chỉ một cú lướt mượt.',
    'Instrument.Keys.Siren.Tagline': 'Lướt mượt mà qua toàn bộ quãng giọng của bạn.',
    'Instrument.Keys.Tonality.Guide': 'Sắc thái là màu cảm xúc bạn dùng để vẽ — ấm áp, tinh nghịch, nghiêm túc, dịu dàng, mạnh mẽ. Cùng một câu chữ có thể an ủi hoặc thách thức, tùy vào tông giọng. Hãy quyết định bạn muốn người nghe cảm thấy thế nào, rồi để cảm giác đó thấm vào giọng bạn.',
    'Instrument.Keys.Tonality.Tagline': 'Màu sắc và cảm xúc trong giọng của bạn.',
    'Instrument.Keys.Volume.Guide': 'Âm lượng là sắc độ mạnh nhẹ. Nâng âm lượng lên sẽ kéo được sự chú ý; hạ xuống gần như thì thầm kéo người nghe lại gần và khiến họ nghiêng người tới. Điều quan trọng là sự tương phản — không phải bạn nói to đến đâu, mà bạn di chuyển giữa to và nhỏ tự do đến mức nào.',
    'Instrument.Keys.Volume.Tagline': 'Bạn nói to hay nhỏ.',
    'Instrument.KeysHeading': 'Năm phím',
    'Instrument.KeysIntro': 'Chạm vào một phím để xem góc nhìn của hướng dẫn AI về nó. Trong khi luyện, một gợi ý sẽ làm sáng phím đó lên khi đến lúc chơi với nó.',
    'Instrument.Lead': 'Giọng nói của bạn có 88 phím. Đọc to một câu chuyện do AI viết trong khi các gợi ý trực tiếp mời bạn chơi — nói nhanh hơn, hạ âm lượng, siren ngay, mỉm cười. Ở đây không có điểm số: đây là một sân chơi. Cứ khám phá thôi.',
    'Instrument.MetaDescription': 'Nhạc cụ — khám phá giọng nói của bạn như một nhạc cụ 88 phím: Tốc độ, Âm lượng, Cao độ & Giai điệu, Sắc thái, Khoảng lặng, Cách nhả chữ, Siren và biểu cảm khuôn mặt, cùng các gợi ý AI trực tiếp.',
    'Instrument.ResumePlaygroundAria': 'Tiếp tục sân chơi',
    'Instrument.ResumePlaying': 'Tiếp tục chơi',
    'Instrument.ReviewTooltip': 'Hãy ghi ít nhất một phút để yêu cầu AI đánh giá.',
    'Instrument.StartOffline': 'Bắt đầu chơi (ngoại tuyến)',
    'Instrument.StartPlaygroundAria': 'Bắt đầu sân chơi',
    'Instrument.StartPlaying': 'Bắt đầu chơi',
    'Instrument.TechniquesHeading': 'Thêm hai kỹ thuật',
    'Instrument.Title': 'Nhạc cụ · VoiceDojo',
    'OffBook.AbortHeading': 'Chúng tôi không viết lại được câu chuyện của bạn',
    'OffBook.AddStoryFirst': 'Thêm câu chuyện của bạn trước',
    'OffBook.AmsDescription': 'Loại suy, ẩn dụ, so sánh.',
    'OffBook.DefaultStoryTitle': 'Câu chuyện của bạn',
    'OffBook.EnrichLegend': 'Làm giàu thêm',
    'OffBook.EnrichOptional': '(tùy chọn)',
    'OffBook.FrameworkAria': 'Khung cấu trúc',
    'OffBook.FrameworkStorytellingFormula': 'Công thức Kể chuyện',
    'OffBook.GuideHeading': 'Thuộc lòng — câu chuyện của bạn, hình dạng của bạn',
    'OffBook.GuideHint': 'Mang đến một câu chuyện bạn muốn kể. AI viết lại và mở rộng nó thành hình dạng bạn chọn và điều chỉnh theo độ dài mục tiêu, rồi chạy nó như một bài đọc to có hướng dẫn với các gợi ý trực tiếp. Khi đã quen, hãy ẩn câu chuyện và các gợi ý để hoàn toàn thuộc lòng.',
    'OffBook.HideCues': 'Ẩn gợi ý',
    'OffBook.HideStory': 'Ẩn câu chuyện',
    'OffBook.NewStory': 'Câu chuyện mới',
    'OffBook.ReadyHint': 'Câu chuyện của bạn đã sẵn sàng. Hãy bắt đầu ghi khi bạn sẵn sàng — đọc to nó và làm theo các gợi ý.',
    'OffBook.ReviewTooltip': 'Hãy ghi ít nhất một phút để yêu cầu AI đánh giá.',
    'OffBook.RewriteRehearse': 'Viết lại & tập',
    'OffBook.RewritingStory': 'Đang viết lại câu chuyện của bạn…',
    'OffBook.ShapeLegend': 'Định hình bằng',
    'OffBook.StartRecording': 'Bắt đầu ghi',
    'OffBook.Step1Heading': '1 · Mang đến câu chuyện của bạn',
    'OffBook.Step2Heading': '2 · Tập bản thu của bạn',
    'OffBook.StoryKindLabel': 'Câu chuyện',
    'OffBook.StoryLabel': 'Câu chuyện của bạn',
    'OffBook.StoryPlaceholder': 'Dán hoặc gõ câu chuyện bạn muốn kể…',
    'OffBook.TakeLengthAria': 'Độ dài bản thu tính bằng phút',
    'OffBook.TakeLengthHint': 'Một bản thu đầy đủ 5–15 phút',
    'OffBook.TakeLengthLabel': 'Độ dài bản thu',
    'OffBook.TellingEyebrow': 'Đang kể',
    'OffBook.VaksDescription': 'Sự phong phú cảm giác — thị giác, thính giác, vận động, vị-khứu giác.',
    'OffBook.WithCuesAria': 'Luyện với gợi ý',
    'OffBook.WithCuesHint': 'Các gợi ý trực tiếp, nhận biết ngữ cảnh trải khắp giọng nói, cơ thể, cử chỉ và nguyên mẫu.',
    'OffBook.WithCuesLabel': 'Luyện với gợi ý',
    'Storytelling.AbortHeading': 'Chúng tôi không tạo được chủ đề của bạn',
    'Storytelling.AmsDescription': 'Loại suy, ẩn dụ, so sánh.',
    'Storytelling.DefaultTopicTitle': 'Chủ đề của bạn',
    'Storytelling.EnrichLegend': 'Làm giàu các gợi ý trợ giúp bằng',
    'Storytelling.EnrichOptional': '(không bắt buộc)',
    'Storytelling.FrameworkAria': 'Khung cấu trúc',
    'Storytelling.FrameworkStorytellingFormula': 'Công thức Kể chuyện',
    'Storytelling.Heading': 'Kể chuyện',
    'Storytelling.Lead': 'Nói từ 3 đến 15 phút về một chủ đề và ghi một bản thu đầy đủ. Sau đó nhận AI đánh giá về cấu trúc và cách truyền đạt của bạn.',
    'Storytelling.MetaDescription': 'Kể chuyện — ghi một bản thu đầy đủ 3–15 phút dựa trên Công thức Kể chuyện và chi tiết cảm giác VAKS, rồi nhận AI đánh giá.',
    'Storytelling.ModeAria': 'Chế độ kể chuyện',
    'Storytelling.ModeImprov': 'Ứng tác',
    'Storytelling.ModeLockedAria': 'Hoàn tất bản thu để đổi chế độ',
    'Storytelling.ModeOffBook': 'Thuộc lòng',
    'Storytelling.NewTopic': 'Chủ đề mới',
    'Storytelling.NoExtraLenses': 'không thêm lăng kính',
    'Storytelling.ReviewTooltip': 'Hãy ghi ít nhất một phút để yêu cầu AI đánh giá.',
    'Storytelling.SetupAria': 'Thiết lập câu chuyện của bạn',
    'Storytelling.ShapeHeading': 'Cấu trúc & gợi ý trợ giúp',
    'Storytelling.ShapeLegend': 'Dựng nó với',
    'Storytelling.SpineTitle': 'Lộ trình của bạn',
    'Storytelling.StartRecording': 'Bắt đầu ghi',
    'Storytelling.StartSession': 'Nhận lộ trình của tôi',
    'Storytelling.TakeLengthAria': 'Độ dài bản thu tính bằng phút',
    'Storytelling.TakeLengthLabel': 'Độ dài bản thu',
    'Storytelling.TellingEyebrow': 'Đang kể',
    'Storytelling.Title': 'Kể chuyện · VoiceDojo',
    'Storytelling.TopicKindLabel': 'Chủ đề',
    'Storytelling.TopicLegend': 'Chủ đề của bạn',
    'Storytelling.TopicMoreIdeas': 'Thêm ý tưởng',
    'Storytelling.TopicPlaceholder': 'Để trống và chúng tôi sẽ chọn giúp bạn',
    'Storytelling.TopicSuggestionsLabel': 'Thử:',
    'Storytelling.VaksDescription': 'Sự phong phú giác quan — thị giác, thính giác, vận động, khứu-vị giác.',
    'Storytelling.WritingTopic': 'Đang viết chủ đề của bạn…',
    'WordPlay.AbortBody': 'Hướng dẫn AI đã bỏ cuộc sau ba lần thử. Lượt luyện tập trong ngày của bạn đã được hoàn lại.',
    'WordPlay.AbortHeading': 'Chúng tôi không chọn được từ cho bạn',
    'WordPlay.DownloadHelpHeading': 'Các gợi ý trợ giúp bạn đã hé lộ:',
    'WordPlay.DownloadWordPrefix': 'Từ: {Word}',
    'WordPlay.GuideAria': 'Hướng dẫn Riff',
    'WordPlay.GuideCopy': 'Bạn nhận một từ tiếng Anh duy nhất. Hãy nói thoải mái về nó trong 1-5 phút — gì cũng được: một ký ức, một mô tả, một câu chuyện, một đoạn lan man. Nếu bạn bí, hãy chạm **Tôi cần trợ giúp!** và AI sẽ hé lộ một gợi ý để giúp bạn tiếp tục. Không có câu trả lời “đúng” nào — đây là sân chơi, không phải bài kiểm tra.',
    'WordPlay.GuideHeading': 'Riff hoạt động thế nào',
    'WordPlay.Heading': 'Riff',
    'WordPlay.HelpPromptsHint': 'Đã có sẵn {Count} gợi ý trợ giúp cho lượt ghi dài như vậy.',
    'WordPlay.IntroCopy': 'Chọn thời lượng bạn muốn nói, rồi nhấn **Bắt đầu riff**.',
    'WordPlay.Lead': 'Ứng tác trên một từ duy nhất.',
    'WordPlay.MetaDescription': 'Riff — ứng tác một từ. Nhận một từ, nói trong 1-5 phút, chạm “Tôi cần trợ giúp!” nếu bạn bí.',
    'WordPlay.NewWord': 'Từ mới',
    'WordPlay.PickingWord': 'Đang chọn từ của bạn…',
    'WordPlay.ResumeSession': 'Tiếp tục phiên',
    'WordPlay.StartRiffing': 'Bắt đầu riff',
    'WordPlay.Title': 'Riff · VoiceDojo',
    'WordPlay.WebGpuRequired': 'Chế độ ngoại tuyến cần WebGPU cho mô hình trong trình duyệt, mà trình duyệt này chưa có — Riff vẫn hoạt động trực tuyến. Để luyện ngoại tuyến, hãy thử Chrome, Edge gần đây, hoặc Firefox 141+.',
    'WordPlay.WordKindLabel': 'Từ',
    'WordPlay.YourWordEyebrow': 'Từ của bạn',
  },
} as const;

